export default function Header() {
  return (
    <header className="header">
      <a href="../" className="link__logo">
        <img
          src="assets/images/logo.webp"
          alt="logo"
          className="header__logo"
        />
      </a>
      <h2 className="header__slogan">Nos photographes</h2>
    </header>
  );
}
